import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCmi5TXB2pXrzEkGdBIbZ2CrQo7MYWLX3E",
  authDomain: "myhomedelcastilho.firebaseapp.com",
  projectId: "myhomedelcastilho",
  storageBucket: "myhomedelcastilho.appspot.com",
  messagingSenderId: "281753412671",
  appId: "1:281753412671:web:30ead57900aee33e99848a",
  measurementId: "G-ELVGGS3090"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export default analytics;
